'use client';

import { useMemo } from 'react';
import GfInteractiveMap from './GfInteractiveMap';
import { distanceKm } from '@/utils/distance';
import { t } from '@/i18n/translations';

const poiTitle = (a) => a?.page?.h1 || a?.nameEn || a?.localName || a?.title || '';

/**
 * Карта города: один listed-слой = POI (нумерованные + список), центр-маркер = центр города,
 * meta = расстояние от центра. Тонкий адаптер над GfInteractiveMap.
 */
export default function CityInteractiveMap({
    cityCoords,
    cityName = '',
    attractions = [],
    lang = 'ru',
    zoom = 13,
    citySlug = '',
    countrySlug = '',
}) {
    const ui = t(lang, 'mapsUi').city;

    const points = useMemo(
        () => (attractions || [])
            .filter((a) => a?.coords?.lat && a?.coords?.lng)
            .map((a) => {
                const slug = a.page?.poiSlug || a.slug?.current || (typeof a.slug === 'string' ? a.slug : null);
                const cSlug = a.citySlug || citySlug;
                const coSlug = a.countrySlug || countrySlug;
                const km = cityCoords ? distanceKm(cityCoords, a.coords) : null;
                return {
                    id: a.id || slug,
                    title: poiTitle(a),
                    subtitle: a.page?.subtitle || '',
                    coords: a.coords,
                    cover: a.cover,
                    href: slug && cSlug && coSlug ? `/${lang}/${coSlug}/${cSlug}/places/${slug}` : null,
                    meta: km != null ? `${km} ${ui.km}` : null,
                };
            }),
        [attractions, cityCoords, lang, citySlug, countrySlug, ui]
    );

    const layers = useMemo(() => [
        { key: 'poi', kind: 'poi', listed: true, swatch: 'var(--pine)', label: ui.attractions, points },
    ], [points, ui]);

    return (
        <GfInteractiveMap
            layers={layers}
            center={cityCoords?.lat && cityCoords?.lng ? { coords: cityCoords, label: cityName } : null}
            panelEyebrow={ui.panelEyebrow}
            hint={ui.hint}
            ariaLabel={ui.aria}
            lang={lang}
            zoom={zoom}
            fitMaxZoom={15}
        />
    );
}
